import type { ToastContextType } from "@/contexts/toastContext";
import { ToastContext } from "@/contexts/toastContext";
import { useContext } from "react";

export const useToast = (): ToastContextType => {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};
